import { render, staticRenderFns } from "./addShopType.vue?vue&type=template&id=25c7512c"
import script from "./addShopType.vue?vue&type=script&lang=js"
export * from "./addShopType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports